import { BaseService } from 'core/services';
import RegisterRouteService from './RegisterRouteService';

class RegisterService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new RegisterRouteService());
    }
}

export default RegisterService;
